import { gql } from '@apollo/client';

export const GET_TOKEN_GROUPS = gql`
  query GetTokenGroups($portfolioId: ID!) {
    tokenGroups(portfolioId: $portfolioId) {
      id
      name
    }
  }
`; 